<template>
  <el-popover
    width="307"
    ref="selectEmojiPopper"
    popper-class="select-emoji-popper"
    trigger="manual"
    v-model="visible"
  >
    <div class="emojis">
      <div v-for="(item, index) in emojis" :key="index" @click="setLook(item)" class="emoji">
        {{ item }}
      </div>
    </div>
    <template slot="reference">
      <slot name="reference"></slot>
    </template>
  </el-popover>
</template>
<script>
import { emojis } from "@/components/Sheet/DetailDialog/static"

export default {
  name: "select-emoji-popper",
  props: {
    visible: Boolean,
    value: Object
  },
  data() {
    return {
      emojis
    }
  },
  methods: {
    setLook(look) {
      this.$emit("setLook", look)
    }
  }
}
</script>

<style lang="scss">
.select-emoji-popper {
  min-width: unset;
  .emojis {
    display: flex;
    flex-wrap: wrap;
    height: 180px;
    white-space: break-spaces;
    .emoji {
      padding: 2px 3px 0 3px;
      font-size: 18px;
      align-items: center;
      display: flex;
      height: 20px;
      &:hover {
        background-color: #e9f5fe;
      }
    }
  }
}
</style>
